(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-aso-videos"] && !Shopify.designMode) return;
  try {
    
  class CsAsoVideos extends HTMLElement {
    connectedCallback() {
      this.player = this.querySelector('[data-featured-player]');
      this.thumbs = this.querySelectorAll('[data-video-thumb]');

      for (const thumb of this.thumbs) {
        thumb.addEventListener('click', this.#handleThumbClick.bind(this));
      }
    }

    #handleThumbClick(event) {
      const thumb = event.currentTarget;
      const type = thumb.dataset.videoType;
      const id = thumb.dataset.videoId;

      if (!this.player || !type || !id) return;

      let src = '';
      if (type === 'youtube') {
        src = `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&autoplay=1`;
      } else if (type === 'vimeo') {
        src = `https://player.vimeo.com/video/${id}?badge=0&autopause=0&autoplay=1&transparent=0&portrait=0&title=0&byline=0`;
      }

      if (src) {
        this.player.src = src;
        this.player.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  customElements.define('cs-aso-videos', CsAsoVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-member-hero"] && !Shopify.designMode) return;
  try {
    
  /* Sticky join bar. Shows once the hero is completely off screen, so it never
     competes with the CTA already visible inside the hero.

     A Web Component because Horizon's morph engine kills inline
     addEventListener on re-render. Scroll-driven rather than
     IntersectionObserver: one getBoundingClientRect per scroll event costs
     almost nothing, and it keeps working in contexts that throttle the
     compositor, where IO callbacks never fire at all.

     Two listeners on purpose. The window one covers normal page scroll. The
     capture-phase one on document also catches scroll raised by a nested
     scrolling container, which is how the theme editor preview scrolls. */
  class CsMemberSticky extends HTMLElement {
    connectedCallback() {
      const bar = this.querySelector('.cs-member-sticky__bar');
      const target = document.querySelector(this.dataset.target || '.cs-member-hero');
      if (!bar || !target) return;

      this.update = () => {
        bar.toggleAttribute('data-show', target.getBoundingClientRect().bottom <= 0);
      };

      addEventListener('scroll', this.update, { passive: true });
      addEventListener('resize', this.update, { passive: true });
      document.addEventListener('scroll', this.update, { passive: true, capture: true });
      this.update();
    }

    disconnectedCallback() {
      if (!this.update) return;
      removeEventListener('scroll', this.update);
      removeEventListener('resize', this.update);
      document.removeEventListener('scroll', this.update, { capture: true });
    }
  }

  if (!customElements.get('cs-member-sticky')) {
    customElements.define('cs-member-sticky', CsMemberSticky);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-collection-menu"] && !Shopify.designMode) return;
  try {
    
  class CollectionFilterGrid extends HTMLElement {
    #boundHandleClick = this.#handleClick.bind(this);

    connectedCallback() {
      this.buttons = this.querySelectorAll('.nav-filter__button');
      this.items = this.querySelectorAll('.ss-collection-menu__card');

      if (this.buttons.length === 0) return;

      const firstButton = this.buttons[0];
      firstButton.classList.add('active');
      this.#updateVisibility(firstButton.getAttribute('data-grid-cat'));

      for (const button of this.buttons) {
        button.addEventListener('click', this.#boundHandleClick);
      }
    }

    disconnectedCallback() {
      for (const button of this.buttons) {
        button.removeEventListener('click', this.#boundHandleClick);
      }
    }

    #handleClick(event) {
      const button = event.currentTarget;
      for (const btn of this.buttons) {
        btn.classList.remove('active');
      }
      button.classList.add('active');
      this.#updateVisibility(button.getAttribute('data-grid-cat'));
    }

    #updateVisibility(selectedCat) {
      const selected = selectedCat.toLowerCase();
      for (const item of this.items) {
        const itemCats = item.getAttribute('data-grid-cat').split(',').map(cat => cat.trim().toLowerCase());
        item.style.display = itemCats.includes(selected) ? 'block' : 'none';
      }
    }
  }

  customElements.define('collection-filter-grid', CollectionFilterGrid);

  } catch(e) { console.error(e); }
})();
})();
